<template>
    <div class="users">
        <v-tabs v-model="tab" fixed-tabs>
            <v-tab
            v-for="t in tabs"
            :key="t.tab"
            :href="`#${t.tab}`"
            >
            {{ t.title }}
            </v-tab>
        </v-tabs>
        <v-container>
            <v-tabs-items v-model="tab">
                <v-tab-item value="users">
                    <users-list></users-list>
                </v-tab-item>
                <v-tab-item value="roles">
                    <roles-list></roles-list>
                </v-tab-item>
                <v-tab-item value="rolesWithUsers">
                    <roles-with-users-list></roles-with-users-list>
                </v-tab-item>
            </v-tabs-items>
               
        </v-container>
    </div>
</template>

<script>
    import usersList from '../components/users/users'
    import rolesList from '../components/users/roles'
    import rolesWithUsersList from '../components/users/rolesWithUsers'
    import common from '../utils/common'
    export default {
        name: "users",
        components: {
            usersList,
            rolesList,
            rolesWithUsersList
        },
        data() {
            return {
                common,
                tab: 'users'
            }
        },
        computed: {
            tabs() {
                const tabs = [
                    {
                        title: 'Users',
                        tab: 'users',
                        permission: 'users'
                    },
                    {
                        title: 'Roles',
                        tab: 'roles',
                        permission: 'roles'
                    },
                    {
                        title: 'Role Reports',
                        tab: 'rolesWithUsers',
                        permission: 'roles'
                    }
                ]
                return tabs.filter(tab => {
                    return common.hasPermissions(tab.permission, ['read'])
                })
            }
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>